var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaderboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 77 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.572 19.826h-21.93v10.232h21.93V19.826z",
    fill: "#DF781B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.572 27.194h-21.93v2.865h21.93v-2.865zM71.572 19.826h-21.93v2.749h21.93v-2.749z",
    fill: "#C15C08"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.814 19.826h-4.172v10.232h4.172V19.826z",
    fill: "#C15C08"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.79 16.981v2.678a.92.92 0 01-.92.92H47.425V16.06H72.87a.92.92 0 01.92.921z",
    fill: "#FFE6CA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.815 16.06h-6.39v4.52h6.39v-4.52z",
    fill: "#FFCE94"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.169 13.854H4.239V30.06h21.93V13.854z",
    fill: "#BCCED5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.169 27.194H4.239v2.865h21.93v-2.865zM26.169 13.854H4.239v2.747h21.93v-2.747z",
    fill: "#99A9AD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.17 13.854h-4.173V30.06h4.173V13.854z",
    fill: "#99A9AD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.387 10.088v4.518H2.942a.92.92 0 01-.921-.921v-2.677a.92.92 0 01.92-.92h25.446z",
    fill: "#DEF2FC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.387 10.089h-6.39v4.518h6.39v-4.518z",
    fill: "#CFE1E5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.82 3.765H23.992V30.06H51.82V3.765z",
    fill: "#FCB043"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.82 27.194H23.992v2.865H51.82v-2.865zM51.82 3.765H23.992v2.749H51.82V3.765z",
    fill: "#DF781B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M53.116 4.518h-30.42a.92.92 0 01-.921-.92V.92a.92.92 0 01.92-.921h30.42a.92.92 0 01.921.92v2.677a.92.92 0 01-.92.921zM74.247 32.665H2.022v-2.556a.92.92 0 01.92-.92h70.384a.92.92 0 01.921.92v2.556z",
    fill: "#FFCE94"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M75.348 35.703H.921a.92.92 0 01-.921-.92v-1.636a.92.92 0 01.92-.92h74.428a.92.92 0 01.92.92v1.635a.92.92 0 01-.92.92z",
    fill: "#FCB043"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39.915 20.806h-.61v-8.663a1.15 1.15 0 00-1.965-.814l-1.711 1.711a1.15 1.15 0 001.373 1.82v5.946h-.649a1.15 1.15 0 100 2.301h3.562a1.15 1.15 0 000-2.301z",
    fill: "#DD5828"
  })));
}
export default SvgLeaderboard;